
const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);
const mobile = window.innerWidth

const menuLeft = document.querySelector('#list-collection-all')
const mainMenu = document.querySelector('overflow-list.overflow-menu')

/*--------------------------------------------------------------------------------
# MENU LEFT COLLECTION PAGE |||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

if(menuLeft){

   document.addEventListener('DOMContentLoaded', function () {
                        document.querySelectorAll('.custom-select').forEach(function (dropdown) {
                          const selected = dropdown.querySelector('.selected');
                          const options = dropdown.querySelectorAll('.options li');
                      
                          selected.addEventListener('click', function () {
                            dropdown.classList.toggle('open');
                          });
                      
                          options.forEach(function (option) {
                            option.addEventListener('click', function () {
                              selected.textContent = option.textContent;
                              dropdown.classList.remove('open');
                      
                              // Redirecionar como o select faria:
                              const url = option.getAttribute('data-url');
                              if (url) {
                                window.location.href = url;
                              }
                            });
                          });
                      
                          // Fecha dropdown se clicar fora
                          document.addEventListener('click', function (e) {
                            if (!dropdown.contains(e.target)) {
                              dropdown.classList.remove('open');
                            }
                          });
                        });
                      });

}

/*--------------------------------------------------------------------------------
# MENU HEADER DESKTOP E MOBILE COLLECTION PAGE |||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

const liChild = document.querySelectorAll('.menu-list__list-item, li.menu-drawer__list-item--deep.menu-drawer__list-item--divider')
const containerMenuAll = document.querySelectorAll('.container-menu-all ul li a')

const resourceListItem = document.querySelectorAll('.resource-list__item')

liChild.forEach((li)=>{
    if(li.textContent.trim() === 'Marcas'){

      const itemMenu = document.createElement('div')      

      li.style.cssText = `
      position: relative;
      `

      itemMenu.innerHTML = `${document.querySelector('.container-menu-all').innerHTML}`
      itemMenu.classList.add('container-menu-all')     

      li.querySelector('a').addEventListener('click', (e)=>{
          e.preventDefault()
          itemMenu.classList.toggle('d-block')
      })

      li.appendChild(itemMenu)

      window.addEventListener('scroll',()=>{

        let scroll = window.scrollY

        if(scroll>60){
          if(itemMenu.classList.contains('d-block')){
              itemMenu.classList.remove('d-block')
            }
          }
      })

    }
})

/*--------------------------------------------------------------------------------
# COLLECTION GRID LIST REPLACE HOME PAGE |||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

  const collectionImgsTop = [
    '/cdn/shop/files/12X1_f273eea6-bac8-4740-90cf-a82d486ac683.jpg?v=1759250598',
    '/cdn/shop/files/CACHOS.jpg?v=1751560900',
    '/cdn/shop/files/HIDRATANTES.jpg?v=1751560900',
    '/cdn/shop/files/NEUTRO.jpg?v=1751560899',
  ];
  const collectionImgsBottom = [
    '/cdn/shop/files/REST-TOTAL.jpg?v=1751560900',
    '/cdn/shop/files/POS-QUIMICA.jpg?v=1751560899',
    '/cdn/shop/files/PLASTIC.jpg?v=1751560900',
    '/cdn/shop/files/MASCARAS.jpg?v=1751560900',
  ];

  const collectionImgsMobile = [
    '/cdn/shop/files/12X1_f273eea6-bac8-4740-90cf-a82d486ac683.jpg?v=1759250598',
    '/cdn/shop/files/CACHOS.jpg?v=1751560900',
    '/cdn/shop/files/HIDRATANTES.jpg?v=1751560900',
    '/cdn/shop/files/NEUTRO.jpg?v=1751560899',
    '/cdn/shop/files/REST-TOTAL.jpg?v=1751560900',
    '/cdn/shop/files/POS-QUIMICA.jpg?v=1751560899',
    '/cdn/shop/files/PLASTIC.jpg?v=1751560900',
    '/cdn/shop/files/MASCARAS.jpg?v=1751560900',
    '/cdn/shop/files/12X1_f273eea6-bac8-4740-90cf-a82d486ac683.jpg?v=1759250598',
    '/cdn/shop/files/CACHOS.jpg?v=1751560900',
    '/cdn/shop/files/HIDRATANTES.jpg?v=1751560900',
    '/cdn/shop/files/NEUTRO.jpg?v=1751560899',
    '/cdn/shop/files/REST-TOTAL.jpg?v=1751560900',
    '/cdn/shop/files/POS-QUIMICA.jpg?v=1751560899',
    '/cdn/shop/files/PLASTIC.jpg?v=1751560900',
    '/cdn/shop/files/MASCARAS.jpg?v=1751560900'
  ]

function replaceImg(selector,array){

  const shopByCollection = document.querySelectorAll(selector);

  if (shopByCollection.length) {
        shopByCollection.forEach(section => {
          const cardImages = section.querySelectorAll('.collection-card__image');
          
          cardImages.forEach((card, i) => {
            if (array[i]) {
              card.style.backgroundImage = `url("${window.location.origin}/${array[i]}")`;
            }
          });
      });
    }
}

replaceImg('#shopify-section-template--20441077153947__collection_list_p4yw3M', collectionImgsTop)
replaceImg('#shopify-section-template--20441077153947__collection_list_8pBkNW', collectionImgsBottom)
replaceImg('#shopify-section-template--20441077153947__collection_list_jmeKK6', collectionImgsMobile)


const listCollection = document.querySelectorAll('.ui-test-collection-list')

if(document.body.classList.contains('index-custom') && listCollection.length>0){

    if(listCollection[0]){

      const listSlide = listCollection[0].querySelectorAll('.resource-list__slide');

      if(mobile<768){
        
          listSlide.forEach((list)=>{
             list.style.width = '40vw'

            setTimeout(() => {
                list.style.opacity = '1'
            }, 400);

        })
      }      
    } 
}

const faqTitle = document.querySelector('#shopify-section-template--20441077153947__section_cpL3dU .group-block-content')

if(faqTitle){
  faqTitle.style.removeProperty('--horizontal-alignment')
  const lastP = document.querySelectorAll('#shopify-section-template--20441077153947__section_cpL3dU rte-formatter p')
  let lastIndex = lastP.length - 1
  lastP[lastIndex].style.paddingBottom = '40px'
}

const productButton = document.querySelectorAll('.product-form-buttons button')

if(productButton){

  productButton.forEach((button) =>{

    button.closest('.group-block-content').style.justifyContent = "flex-end"

  })

}

if(document.body.classList.contains('page-custom')){

  let h1Page = document.querySelector('h1')

  if(mobile<768){
    h1Page.style.fontSize = '25px'
  }

}


if(
  document.body.classList.contains('product-linha-acidificante-custom') ||
  document.body.classList.contains('product-defrizante-custom') ||
  document.body.classList.contains('product-linha-12-em-1-custom') ||
  document.body.classList.contains('product-linha-cachos-africanos-custom') ||
  document.body.classList.contains('product-pos-quimica-custom') ||
  document.body.classList.contains('product-uo-custom')
  ){
      
      const detailsP = document.querySelectorAll('.details-content p')
      let lastIndex = detailsP.length - 1
      if(detailsP && mobile<992){
        detailsP[lastIndex].style.paddingBottom = '60px';        
      }
}

const jdgmContent = document.querySelector('.jdgm-content')

if(jdgmContent && document.body.classList.contains('index-custom')){

  jdgmContent.querySelectorAll('.jdgm-arrow')[0].querySelector('svg').style.margin = '0 auto'
  jdgmContent.querySelectorAll('.jdgm-arrow')[1].querySelector('svg').style.margin = '0 auto'

  if(mobile<768){
    jdgmContent.style.gap = '0';
    jdgmContent.style.marginBottom = '-10px';
  }

}

if (document.body.classList.contains('page-rastrear-pedido-custom')) {

    document.addEventListener('DOMContentLoaded', () => {

        const trackingInput = document.querySelector('input#cod_rastreio');
            const buttonTracking = document.querySelector('button#formSearchNumber');            
            const preencherRastreioPelaURL = () => {                
                const params = new URLSearchParams(window.location.search);               
                
                if (params.has('objeto')) {                    
                    const codigoRastreio = params.get('objeto');                    
                   
                    trackingInput.value = codigoRastreio.trim();
                }
            };
          
            if (!trackingInput || !buttonTracking) return;

            preencherRastreioPelaURL();

            trackingInput.addEventListener('input', (e) => {
                const valorSemEspacos = e.target.value.replace(/\s/g, '');
                e.target.value = valorSemEspacos;
            });

            const handleRedirect = () => {
                const trackingCode = trackingInput.value.trim();
                const encodedTrackingCode = encodeURIComponent(trackingCode);

                if (trackingCode.length === 0) {
                    alert("Por favor, insira um código de rastreio.");
                    return;
                }

                if (trackingCode.length > 9) {
                    window.open(`https://rastreamento.correios.com.br/app/?objetos=${encodedTrackingCode}`, "_blank", "noopener,noreferrer");
                } else {
                    window.open(`https://app.loggi.com/rastreador/${encodedTrackingCode}/historico?utm_source=organic&utm_medium=site_loggi_acesso_plataformas&utm_campaign=btn_acessar_app`, "_blank", "noopener,noreferrer");
                }

                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('objeto', trackingCode);
                window.history.replaceState({}, '', currentUrl);
            };

            buttonTracking.addEventListener('click', handleRedirect );

            trackingInput.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault(); 
                    handleRedirect();
                }
            });

    });
}



// Fluxo antigo de rastreio removido na limpeza pré-golive.












